import { Controller } from "@hotwired/stimulus"

// Hält den „Anruf starten“-Link mit einer Nummern-Auswahl synchron (Phonecall-Modal, mehrere Rufnummern).
export default class extends Controller {
  static targets = ["telLink", "select"]
  static values = {
    prefix: { type: String, default: "tel" }
  }

  connect() {
    this.syncTel()
  }

  syncTel() {
    if (!this.hasTelLinkTarget || !this.hasSelectTarget) return
    const raw = this.selectTarget.value || ""
    this.telLinkTarget.href = this.buildHref(raw)
  }

  buildHref(raw) {
    const cleaned = (raw || "").replace(/\s+/g, "")
    if (!cleaned) return "#"
    return `${this.prefixValue}:${cleaned}`
  }
}
